/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";

import { AuthRoutingModule } from "./auth-routing.module";
import { NbAuthModule } from "@nebular/auth";
import {
    NbAlertModule,
    NbButtonModule,
    NbCheckboxModule,
    NbInputModule,
    NbCardModule,
    NbLayoutModule,
} from "@nebular/theme";

import { LoginComponent } from "./login/login.component";
import { SharedModule } from "../shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { LoginLightComponent } from "./login-light/login-light.component";
import { TwoFactorAuthComponent } from "./two-factor-auth/two-factor-auth.component";
import { SignUpComponent } from "./sign-up/sign-up.component";
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NbAlertModule,
        NbInputModule,
        NbButtonModule,
        NbCheckboxModule,
        AuthRoutingModule,
        NbInputModule,
        NbCardModule,
        SharedModule,
        NbAuthModule,
        NbLayoutModule,
        TranslateModule,
        ReactiveFormsModule,
    ],
    exports: [
        NbAlertModule,
        NbInputModule,
        NbButtonModule,
        NbCheckboxModule,
        AuthRoutingModule,
        NbInputModule,
        NbCardModule,
        NbAuthModule,
        NbLayoutModule,
    ],
    declarations: [LoginComponent, LoginLightComponent, TwoFactorAuthComponent, SignUpComponent],
    entryComponents: [LoginLightComponent],
})
export class AuthModule {}
